import * as Random from "@std/random";

const thinking = [
  "Thinking",
  "Thinking",
  "Thinking",
  "Pondering",
  "Reasoning",
  "Reflecting",
  "Analyzing",
  "Evaluating",
  "Meditating",
  "Meditating",
  "Meditating",
  "Meditating deeply",
  "Musing",
  "Mulling",
  "Deliberating",
  "Speculating",
  "Contemplating",
  "Considering",
  "Deducing",
  "Introspecting",
  "Understanding",
  "Cognizing",
  "Intuiting",
  "Formulating",
  "Hmm",
  "Hmmm",
  "Marinating",
  "Focusing",
  "Exploring",
  "Exploring latent space",
  "Reticulating splines",
  "Vibing",
  "Shape rotating",
  "Pivoting",
  "Pivoting hyperobjects",
  "Matrix multiplying",
  "Multiplying matrices",
  "Normalizing vectors",
  "Folding dimensions",
  "Folding latent space",
  "Thaumaturging",
  "Strategizing",
  "Philosophizing",
  "Buffering",
  "Communing with the universe",
  "Channeling cosmic energies",
  "Tuning into cosmic frequencies",
  "Summoning",
  "Triangulating truth vectors",
  "Rolling a d20 for insight",
  "Voidcasting",
  "Consulting the oracles",
  "Photosynthesizing",
  "Levitating",
  "Boondoggling",
  "Zigzagging",
  "Perambulating",
  "Frolicking",
  "Twizzling",
  "Twirling",
  "Transmogrifying",
  "Transfiguring",
  "Cartwheeling",
  "Pirouetting",
  "Pouncing",
  "Cerebrating",
  "Combobulating",
  "Orchestrating",
  "Concocting",
  "Ensorcelling",
  "Enchanting",
  "Spellcasting",
  "Schlepping",
  "Bewitching",
  "Conjuring",
  "Invoking",
  "Incanting",
  "Weaving",
  "Manifesting",
  "Mystifying",
  "Hustling",
  "Generating",
  "Crafting",
  "Hashing",
  "Shimmering",
  "Glowing",
  "Sparkling",
  "Crunching",
  "Glimmering",
  "Delving",
  "Delving",
  "Delving",
  "Caramelizing",
  "Reducing",
  "Simmering",
  "Cooking",
  "Cooking",
  "Cooking",
  "Melting",
  "Zooming",
  "Zooming",
  "Zooming",
  "Infusing",
  "Brewing",
  "Elucidating",
  "Educing",
  "Stippling",
  "Propagating",
];

/** Picks a "thinking" string at random */
export const randomThinking = (fallback = ""): string => {
  return Random.sample(thinking) ?? fallback;
};
